import React from 'react';
import {InfoSectionLayoutId} from '../../constants';
import {CollapseInfoSection} from './Layouts/CollapseInfoSection/CollapseInfoSection';
import {StackedInfoSection} from './Layouts/StackedInfoLayout/StackedInfoSection';
import {ColumnsInfoSection} from './Layouts/ColumnsInfoLayout/ColumnsInfoSection';
import {ProvidedGlobalProps, withGlobalProps} from '../../providers/globalPropsProvider';
import {
  geColumnNumberFromGlobalProps,
  geTabFontFromGlobalProps,
  getAdditionalInfoFromGlobalProps,
  getDirectionFromGlobalProps,
  getInfoSectionExpandFirstFromGlobalProps,
  getInfoSectionLayoutTypeFromGlobalProps,
  getIsRtlFromGlobalProps,
  getOnActiveBIEventHandler,
  getAlignmentFromGlobalProps,
} from './InfoSectionLayoutUtils';
import {InfoSectionEvent} from '../../types/app-types';
import {IProductInfo} from '@wix/wixstores-graphql-schema';
import {TabsInfoSectionTPA as TabsInfoSection} from './Layouts/TabsInfoLayout/TabsInfoSectionTPA';
import {TabsInfoSection as TabsInfoSectionOld} from './Layouts/TabsInfoLayout/TabsInfoSection';

export interface InfoSectionProps extends ProvidedGlobalProps {
  infoSectionItems: IProductInfo[];
}

export const InfoSectionLayout: React.FC<ProvidedGlobalProps> = withGlobalProps((props) => {
  const handleBIEvent = (BIEvent: InfoSectionEvent) => {
    const onActive = getOnActiveBIEventHandler(props);
    onActive(BIEvent);
  };

  const renderLayout = () => {
    const layoutId = getInfoSectionLayoutTypeFromGlobalProps(props);
    const infoSectionItems = getAdditionalInfoFromGlobalProps(props);
    const numberOfColumns = geColumnNumberFromGlobalProps(props);
    const tabFontStyle = geTabFontFromGlobalProps(props);
    const dir = getDirectionFromGlobalProps(props);
    const isRTL = getIsRtlFromGlobalProps(props);
    const alignment = getAlignmentFromGlobalProps(props);
    const shouldExpandFirstInfoSection = getInfoSectionExpandFirstFromGlobalProps(props);
    const shouldRenderNewTabs = props.globals.experiments.infoSectionTabsTPAComponent;
    const updateLayout = props.globals.updateLayout;
    const infoSectionProps = {
      key: `info-section-${props.globals.product.id}`,
      infoSectionItems,
    };
    switch (layoutId) {
      case InfoSectionLayoutId.Collapse:
        return (
          <CollapseInfoSection
            {...infoSectionProps}
            handleBIEvent={handleBIEvent}
            shouldExpandFirstInfoSection={shouldExpandFirstInfoSection}
            updateLayout={updateLayout}
          />
        );
      case InfoSectionLayoutId.Stacked:
        return <StackedInfoSection infoSectionItems={infoSectionItems} />;
      case InfoSectionLayoutId.Columns:
        return <ColumnsInfoSection {...infoSectionProps} numberOfColumns={numberOfColumns} isRTL={isRTL} />;
      case InfoSectionLayoutId.Tabs:
        return shouldRenderNewTabs ? (
          <TabsInfoSection
            {...infoSectionProps}
            handleBIEvent={handleBIEvent}
            tabFontStyle={tabFontStyle}
            alignment={alignment}
            isRTL={isRTL}
          />
        ) : (
          <TabsInfoSectionOld
            {...infoSectionProps}
            handleBIEvent={handleBIEvent}
            tabFontStyle={tabFontStyle}
            direction={dir}
            isRTL={isRTL}
          />
        );
    }
  };

  return <div dir="ltr">{renderLayout()}</div>;
});
